import { IAsyncType, useAsync } from '.';

import { amsV3Service } from '../../services';

export interface IEnvCurrency<T> extends IAsyncType<T> {
  currency: T;
}

const useEnvCurrency = (): IEnvCurrency<string> => {
  const { data, loading, setLoading, parameters, setParameters } = useAsync<any>(
    amsV3Service.getEnvironmentCurrency,
    'EUR',
    [],
    true
  );
  return {
    currency: data ?? 'EUR',
    loading,
    setLoading,
    parameters,
    setParameters
  };
};

export default useEnvCurrency;
